import React from "react"
import { Link } from "react-router-dom"

import { LANGUAGE } from "actions/constants"

export default {
    [LANGUAGE.EN]: {
        Heading: () => <>RSVP</>,
        //SubHeadingAuthenticated: ({ user }) => (
        //    <span>
        //        <Link to="/auth">Sign in</Link> to manage your RSVP. Don't have
        //        an account? <Link to="/auth/signup">Sign up</Link> now!
        //    </span>
        //),
        SubHeading: () => (
            <span>
                We can't wait to see you in Chiang Mai!
            </span>
        ),
    },
    [LANGUAGE.ZH]: {
        Heading: () => <>请尽快回复</>,
        //SubHeadingAuthenticated: ({ user }) => (
        //    <span>
        //        <Link to="/auth">Inicieu la sessió</Link> per confirmar-nos la
        //        vostra asistència. No teniu un compte?{" "}
        //        <Link to="/auth/signup">Registreu-vos</Link>!
        //    </span>
        //),
        SubHeading: () => (
            <span>
                我们迫不及待地想在清迈见到您！
            </span>
        ),
    },
}
